import { Component } from '@angular/core';

@Component({ template: '', selector: 'bar-empty' })
export class BarEmptyComponent {}
